export const INTEGRATION_KEY = {
  INTEGRATION_KEY_TITLE: { key: 'INTEGRATION_KEY_TITLE', value: 'Api Integration Key' },
  ENTERPRISE_INTEGRATION_KEY_TITLE: { key: 'ENTERPRISE_INTEGRATION_KEY_TITLE', value: 'Integration Key' },

  API_KEY_LABEL: { key: 'API_KEY_LABEL', value: 'API Key' },

  REGENERATION_WARNING_MESSAGE: {
    key: 'REGENERATION_WARNING_MESSAGE',
    value:
      'Here is the API key provided for your integration with third-party systems. You have the option to generate a new key by clicking the "regenerate" button. Keep in mind that once the key is regenerated, the old key will no longer be functional.',
  },
  REGENERATE_CONFIRMATION_MESSAGE: {
    key: 'REGENERATE_CONFIRMATION_MESSAGE',
    value:
      'Should you opt to regenerate the key, please be aware that the previous key will become invalid and cease to function. Would you like to proceed with this action?',
  },
  COPIED_SUCCESS_MESSAGE: { key: 'COPIED_SUCCESS_MESSAGE', value: 'Copied' },
  REGENERATED_SUCCESS_MESSAGE: {
    key: 'REGENERATED_SUCCESS_MESSAGE',
    value: 'The API key has been regenerated successfully.',
  },

  LOADING_TEXT: { key: 'LOADING_TEXT', value: 'Loading' },

  COPY_CLIPBOARD_TOOLTIP: { key: 'COPY_CLIPBOARD_TOOLTIP', value: 'Copy to clipboard' },

  COPY_BUTTON: { key: 'COPY_BUTTON', value: 'Copy' },
  REGENERATE_BUTTON: { key: 'REGENERATE_BUTTON', value: 'Regenerate API Key' },
  REGENERATING_BUTTON: { key: 'REGENERATING_BUTTON', value: 'Regenerating' },
  PROCEED_BUTTON: { key: 'PROCEED_BUTTON', value: 'Proceed' },
};
